export const truncateText = (text, characthers) => {
  // Join the first two sentences and add '...' if there are more sentences
  const truncatedText =
    text?.slice(0, characthers) + (text.length > characthers ? "..." : "");
  return truncatedText;
};
export function parseDateString(dateString) {
  const parts = dateString.split(" "); // Split de string op spaties
  const month = parts[0]; // Eerste deel is de maand
  const day = parseInt(parts[1]); // Tweede deel is de dag (zorg ervoor dat het een getal is)
  const year = parseInt(parts[2]); // Derde deel is het jaar (zorg ervoor dat het een getal is)

  // Maanden in JavaScript zijn zero-based, dus je moet de maandindex ophalen
  const monthIndex = new Date(Date.parse(`${month} 1, 2000`)).getMonth();

  if (!isNaN(monthIndex) && !isNaN(day) && !isNaN(year)) {
    // Als alle delen geldige getallen zijn, maak een datum
    const date = new Date(year, monthIndex, day);
    return date;
  }

  return null; // Return null als de string niet kan worden geparsed
}

export function formatDate(date) {
  if (date) {
    const day = date.getDate().toString().padStart(2, "0"); // Dag met voorloopnullen
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Maand met voorloopnullen (Januari is 0-indexed)
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }

  // Handle the case when date is null or undefined
  return "";
}

export const hexToRgb = (hex) => {
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  const curr = hex.replace(shorthandRegex, function (m, r, g, b) {
    return r + r + g + g + b + b;
  });

  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(curr);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null;
};

export function isChannelMandatory(channelData) {
  return (
    channelData.hasOwnProperty("facebook_mandatory") ||
    channelData.hasOwnProperty("instagram_mandatory") ||
    channelData.hasOwnProperty("pinterest_mandatory") ||
    channelData.hasOwnProperty("thursd_mandatory")
  );
}

export const updateFormData = (data, formDataWithImage) => {
  for (const [key, value] of Object.entries(data)) {
    formDataWithImage.append(key, value);
  }
  return formDataWithImage;
};
export function removeNulls(obj) {
  for (let prop in obj) {
    if (obj[prop] === null) {
      delete obj[prop];
    } else if (typeof obj[prop] === "object") {
      // Als de waarde een object is, roep de functie recursief aan
      removeNulls(obj[prop]);
      // Verwijder de eigenschap als het object leeg is
      if (Object.keys(obj[prop]).length === 0) {
        delete obj[prop];
      }
    }
  }
}
export const queryStringToArray = (queryString) => {
  var splitByAmpersand = queryString.split("&");
  var resultArray = [];

  splitByAmpersand.forEach(function (item) {
    // Decodeer de deelstring voordat deze aan de array wordt toegevoegd
    resultArray.push(decodeURIComponent(item));
  });
  return resultArray;
};

export function isDictionary(obj) {
  return typeof obj === "object" && obj !== null && !Array.isArray(obj);
}

export function isValueInDictionary(obj, value) {
  const values = Object.values(obj);
  return values.includes(value);
}

export const isEmptyObject = (obj) => {
  if (typeof obj === "object") {
    return Object.keys(obj).length === 0;
  } else {
    return false;
  }
};

export const objectHasEmptyValue = (obj) => {
  if (typeof obj === "object") {
    return Object.values(obj).includes(null);
  }
};

export const findValueByKey = (obj, keyToFind) => {
  for (const key in obj) {
    if (key === keyToFind) {
      return obj[key];
    }
  }
  return null; // Return null (of een andere waarde) als de sleutel niet wordt gevonden
};

export const findKeyByValue = (object, valueToFind) => {
  return Object.keys(object).find((key) => object[key] === valueToFind);
};
export const rgba = (hex, alpha) => {
  const color = hexToRgb(hex);
  return `rgba(${color?.r}, ${color?.g}, ${color?.b}, ${alpha})`;
};

export const openEmail = () => {
  // 	const email = "hello@my.thursd.com";
  // 	const subject = "I want to create a project";
  // 	const body = encodeURIComponent(`***This is an auto-generated text.. Feel free to change the text below.***

  // Dear myThursd team member,

  // I would like to create a project on myThursd. Can you send me the link for the form?

  // Best,

  // `);

  window.open(`https://forms.gle/NbMqe8RBXbDhfrvEA`);
};

export const openEmailTeam = () => {
  const email = "hello@my.thursd.com";
  const subject = "Talk to a team member";
  const body =
    encodeURIComponent(`***This is an auto-generated text.. Feel free to change the text below..***

Dear myThursd team member,
	
I have something to ask / say.
	
Best,

`);
  window.open(`mailto:${email}?subject=${subject}&body=${body}`);
};

export const isRichTextNotEmpty = (content) => {
  if (!content) return false;

  const trimmedContent = content.replace(/<[^>]*>/g, "").trim();
  return trimmedContent !== "";
};
